/*
 * @Author: your name
 * @Date: 2022-01-12 10:47:12
 * @LastEditTime: 2022-01-12 10:48:44
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \wp-empowerment-tools-web\src\services\communicate.ts
 */

import { COMMUNICATE } from "../const"
import request from "../utils/request"

const addRecord = (params: any) => {
  return request.post(`${COMMUNICATE.addRecord}`, { data: params })
}

const getlastesRecord = (params: any) => {
  return request.get(`${COMMUNICATE.getlastesRecord}`, { params })
}

const getCommunicateType = (params: any) => {
  return request.post(`${COMMUNICATE.getCommunicate}`, { data: params })
}

const getFinishCodeList = (params: any) => {
  return request.get(`${COMMUNICATE.getFinishCodeList}`, { params })
}

const getFirstCodeList = (params: any) =>
  request.get(`${COMMUNICATE.getFirstCodeList}`, { params })

  const getQywxContactType = (customerId: string | number, params: any) => {
    return request.get(`${COMMUNICATE.getQywxContactType}/${customerId}`, {
      params,
    })
  }
export {
  getlastesRecord,
  getFinishCodeList,
  getFirstCodeList,
  getCommunicateType,
  getQywxContactType,
  addRecord,
}
